import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { StatusNotificationItem } from '../sales-package';
import { ActivationStatus } from '@vendasta/sales-orders';

export enum ListIndent {
  INDENT_ZERO = 'indent-zero',
  INDENT_ONE = 'indent-one',
  INDENT_TWO = 'indent-two',
}

export interface MenuItemInterface {
  label: string;
  icon: string;
  value: string;
  eventType: MenuItemEventType;
}

export enum MenuItemEventType {
  IGNORE_ACTIVATION_ERRORS = 'ignore-errors',
}

export interface MenuItemClickedInterface {
  value: string;
  eventType: MenuItemEventType;
}

@Component({
  selector: 'sales-ui-sales-order-package-dropdown-item',
  templateUrl: './package-dropdown-item.component.html',
  styleUrls: ['./package-dropdown-item.component.scss', '../package-dropdown.component.scss'],
  standalone: false,
})
export class SalesOrderPackageDropdownItemComponent {
  @Input() title: string;
  @Input() editionName: string;
  @Input() previousEditionName: string;
  @Input() titleDescriptor: string;
  @Input() iconUrl: string;
  @Input() secondaryIconUrl: string;
  @Input() secondaryIconName: string;
  @Input() subtitle: string;
  @Input() statusItem: StatusNotificationItem;
  @Input() enableDropdown = false;
  @Input() enableMenu = false;
  @Input() indent = ListIndent.INDENT_ZERO;
  @Input() toggleValue: boolean;
  @Input() description: string;
  @Input() menuItems: MenuItemInterface[] = [];
  @Input() first = false;
  @Input() showMenuItems = false;
  @Output() menuItemClicked: EventEmitter<MenuItemClickedInterface> = new EventEmitter<MenuItemClickedInterface>();
  @Output() itemToggled: EventEmitter<null> = new EventEmitter<null>();

  @ViewChild('errorRef') errorRef;

  toggleItem(): void {
    this.itemToggled.emit(null);
  }

  calculateClassFromStatus(status: ActivationStatus): string {
    switch (status) {
      case ActivationStatus.ACTIVATED:
      case ActivationStatus.IGNORED_ERRORS:
        return 'activated';
      case ActivationStatus.ALREADY_ACTIVATED:
        return 'warning';
      case ActivationStatus.ERRORED:
        return 'error';
      default:
        return 'pending';
    }
  }

  menuItemClick(item: MenuItemInterface): void {
    this.menuItemClicked.emit({ value: item.value, eventType: item.eventType });
  }

  statusText(status: ActivationStatus): string {
    if (status === ActivationStatus.ALREADY_ACTIVATED) {
      return 'FRONTEND.SALES_UI.ACTIVATION_STATUS.ALREADY_ACTIVATED';
    }

    return '';
  }
}
